
// Title
export const STATION_SATCOM_TITLE = 'Station Satcom';
export const PAL_CARE_TITLE = 'PALCare';
export const VIKAND_TITLE = 'Vikand';
export const SEA_DANCE_TITLE = 'Sea-Dance';
export const ONSHIP_TITLE= 'onship';
export const SEMEDIX_TITLE= 'Seamedix';


//FAV icon
export const STATION_SATCOM_FAViCON = '/images/satComFav.png';
export const PAL_CARE_FAViCON = '/images/mariApps-logo.png';
export const SEA_DANCE_FAViCON = '/images/sea-dance-domain/smallLogoTransparent.png';
export const ONSHIP_FAViCON = '/images/frontm-logo.png';
